import { useQuery } from '@tanstack/react-query'

import { apiGetMissions } from '@/apis/mission/getMissions'

import { MISSION_KEYS } from '../keys/mission'

export const useGetMissions = () => {
  return useQuery({
    queryKey: [MISSION_KEYS.STATUS],
    queryFn: apiGetMissions,
  })
}
